import React from "react";
import { cls } from "cls";
import currencyFormatter from "@wss/utilities/formatAsCurrency";
import { VariationGroupItem } from "./ProductDetailPageResult";
import { selectedTileButtonBorderStyling, baseHoverStyling } from "./VirtualGrouping/VirtualGroupingTiles.styles";
import QuantityPlusBadge from "./Shared/QuantityPlusBadge";
import variationAnalyticsClickTracking from "../analytics/PdpPageTracking/variationAnalyticsClickTracking";
interface QuantityVariationItemProps {
  groupItem: VariationGroupItem;
  isAnyItemInGroupPlusEligible: boolean;
  isSelected: boolean;
  href: string;
  itemNumber: string;
}
const QuantityVariationItem = ({
  groupItem,
  isAnyItemInGroupPlusEligible,
  isSelected,
  href,
  itemNumber
}: QuantityVariationItemProps) => {
  return <a href={href} aria-current={isSelected ? "page" : "false"} data-testid={groupItem.isWebstaurantPlusEligible ? "webplus-quantity-flag" : "plus-ineligible-quantity"} onClick={() => {
    variationAnalyticsClickTracking(groupItem.seoLink, groupItem.variationText);
  }} className={cls("text-sm", "flex", "flex-col", "justify-center", "text-center", "relative before:content-['']", "before:absolute", "before:inset-0", "before:border-solid", "before:rounded", "rounded", "focus-visible:before:border-[3px]", "focus-visible:before:border-[#005FCC]", isAnyItemInGroupPlusEligible ? "py-[19px] px-2 before:z-5 h-full box-border" : "p-3", baseHoverStyling, itemNumber === groupItem.itemNumber ? selectedTileButtonBorderStyling : "before:border before:border-gray-600")} data-sentry-component="QuantityVariationItem" data-sentry-source-file="QuantityVariationItem.tsx">
      <span className={cls("text-base", "text-gray-800", "block", "leading-none", "font-semibold")}>
        {groupItem.variationText}
      </span>
      <span className={cls("text-sm", "text-red-500", "block", "leading-none", "font-bold")}>
        {currencyFormatter.formatIfUndefined(groupItem.productPrice)}
      </span>
      {groupItem.isWebstaurantPlusEligible && <QuantityPlusBadge />}
    </a>;
};
export default QuantityVariationItem;